.inlineLabel {
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  align-items: center;
}

.root {
  display: flex;
}

.body {
  display: flex;
  align-items: center;
}
